import { useDispatch, useSelector } from 'react-redux';
import NotesTextArea from '../../components/fields/NotesTextArea';
import { saveEscalation } from '../../actions/EscalationActions';
import { jsx as _jsx } from "react/jsx-runtime";
function BillingEscalation() {
  const dispatch = useDispatch();
  const escalation = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseCrmComponents' does not exist on ty... Remove this comment to see the full error message
  ({
    zorseCrmComponents: state
  }) => state.escalation);
  const savingState = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseCrmComponents' does not exist on ty... Remove this comment to see the full error message
  ({
    zorseCrmComponents: state
  }) => state.savingState);
  return /*#__PURE__*/_jsx(NotesTextArea, {
    currentText: escalation.notes,
    "data-test-id": "notes-text-area",
    isSaving: savingState.notes,
    onTextChange: text => dispatch(saveEscalation(escalation.setNotes(text).toJS(), 'notes'))
  });
}
export default BillingEscalation;